<template>
  <span
    class="loader"
    :class="[
      `loader--${size}`,
      `loader--tone-${tone}`,
      { 'loader--block': block }
    ]"
  >
    <span class="loader__text" v-if="text">{{ text }}</span>
    <span class="loader__spinner" aria-hidden="true"></span>
  </span>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  size: {
    type: String,
    default: 'md',
    validator: value => ['sm', 'md', 'lg'].includes(value),
  },
  tone: {
    type: String,
    default: 'primary',
    validator: value => ['primary', 'inherit'].includes(value),
  },
  block: { type: Boolean, default: false },
})
</script>
